/*
 * Creates a catalog, optionally uses vuex store
 *
 * Usage: catalogService.create('highway', highway)
 *          .then(=> ...)
 *
 * Vuex integration: catalogService.create('highway', highwayData,
 *                                         {useStore: true})
 */

import Vue from "vue";
import store from "./../../store";
import catalogTransformers from "./../../transformers/catalog";

const success = function (payload) {
  store.dispatch("catalogs/create", payload);
};

export default (type = "", payload, options = {}) => {
  const transformer = catalogTransformers[type];
  if (transformer && transformer.send) {
    payload = transformer.send(payload);
  }

  const { path, ...requestOptions } = options;
  const typeSlasehd = type.endsWith("/") ? type : `${type}/`;
  const base = `/${path || "catalogs"}/${typeSlasehd}`;
  let request = Vue.$http.post(base, payload, requestOptions);
  //request = options.dontMakeErrorMessage ? request : errorHandler(request)

  return request.then((response) => {
    let data = response.data;

    if (transformer && transformer.fetch) {
      data = transformer.fetch(data);
    }

    if (options.useStore) {
      success({ type: type, data: data });
    }

    const source = options.source;
    if (source) {
      source.push(data);
    }

    return data;
  });
};



// WEBPACK FOOTER //
// ./src/services/catalog/create.js